import { IsString, IsOptional } from "class-validator";
import { ICustomerContact } from "./customer-contact.interface";

export class CustomerContactDto implements Omit<ICustomerContact, "_id"> {
  @IsString()
  display_name: string;

  @IsOptional()
  @IsString()
  email?: string;

  @IsOptional()
  @IsString()
  phone?: string;

  @IsOptional()
  @IsString()
  position?: string;
}
